import { Guid } from 'guid-typescript';
import { IDealershipDetails } from '../../models/dealership-details/dealership-details';

export class UserProfile {
  public Guid: Guid;
  public FirstName: string;
  public LastName: string;
  public Email: string;
  public UserName: string;
  public Role: string;
  public InstanceGuid: Guid;
  public StateCode: string;
  public StateDescription: string;
  public CountryCode: string;
  public Program: string;
  public AgentNumber: string;
  public StateLicenseNumber: string;
  public ContactPhone1: string;
  public ContactPhone2: string;
  public SystemRole: string;
  public Active: boolean;
  public Address1: string;
  public Address2: string;
  public City: string;
  public Client: Client;
  public BranchId: string;
  public ZipCode: string;
  public SitefinitySiteId: string;
  public ParentSitefinitySiteId: string;
  public DefaultCulture: string;
  public Name: string;
  public DealerCode: string;
  public isOIPA: boolean;
  public Id: string;
  public IsAU: boolean;
  public DealershipDetails?: IDealershipDetails;
  public DefaultRole?: string;
}


export class Client {
  public ClientId: Guid;
  public Name: string;
  public SitefinitySiteId: Guid
  public DefaultCulture: string;
  public ParentSitefinitySiteId: Guid;
}
